import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { KmsEnum } from '../../../serves/kms-enum';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';

@Component({
  selector: 'app-get-instance',
  templateUrl: './get-instance.component.html',
  styleUrls: ['./get-instance.component.css']
})
export class GetInstanceComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  datas:any = [];  // 词条属性列表
  attrs:any = [];  // 模型中可选的属性
  name = '';   // 词条名称
  conceptName = '';  // 词条绑定概念id
  instance:any = {
    "currentUserRole": null,
    "serialNumber": "",
    "conceptId": "",
    "conceptCode": "",
    "mapping": "",
    "conceptName": "",
    "instanceId": "",
    "instanceName": "",
    "attributes": [],
    "tags": [],
    "geoSaveList": [],
    "deleteAttrIds": [],
    "approvalStatus": 0
  }
  clickEnable = true;
  constructor(
    private jwt: SwJwtService,
    private box: SwMassageBoxService,  //消息提示框
    private kmsService: KmsService,   //请求服务
    private instanceModuleService: InstanceModuleService,
    private swMaskService: SwMaskService
  ) { }

  ngOnInit() {
    this.clickLoca(this.param["selectedData"]);
  }

  //知识库点击新增 或者 修改
  clickLoca(selectedData: any) {
    // 查询详情
    let params = {
      "name": selectedData.name,
      "uniqueId": selectedData.uniqueId
    }
    this.kmsService.queryRdfList(params).subscribe(
      data => {
        if (data.code == '200') {
          this.datas = data.data ? data.data : [];
          this.datas.forEach(el => {el.selected = el.attributeId ? true : false;});
        } else {
          console.log(data.msg);
        }
      }
    );
    this.name = selectedData.name;
    this.conceptName = selectedData.conceptName;
    const userRole = this.jwt.getToken('userRole');
    this.instance.currentUserRole = userRole == '知识编辑' ? 1 : 2;
    // 通过标识自动生成序列号数据
    this.getInstanceMaxSerialNumber();
    // 获取实体id
    this.instance.instanceId  = this.instanceModuleService.uuid2();
    // 获取实体名称
    this.instance.instanceName = selectedData.name;
    // 获取实体所属概念相关参数
    this.instance.conceptId = selectedData.conceptId;
    this.getConceptParams();
    this.queryAttrsByConceptId();
  }

  // 通过标识自动生成序列号数据
  getInstanceMaxSerialNumber() {
    this.kmsService.getInstanceMaxSerialNumber().subscribe(
        result => {
            if (result.code == '200') {
                this.instance.serialNumber = result.data;
            }
        }
    );
  }

  // 获取概念信息
  getConceptParams(){
    this.kmsService.getConceptTreeData({}).subscribe(
      res => {
        if(res.code == '200'){
          let item = res.data.find(el => el.id == this.instance.conceptId);
          if(item){
            this.instance.conceptName = item.name;
            this.instance.conceptCode = item.code;
            this.instance.mapping = item.mapping;
          }
        }
      }
    )
  }

  // 根据概念id查询属性字段配置
  queryAttrsByConceptId(){
    this.kmsService.getAttributeForForm(this.instance.conceptId).subscribe(
      res => {
        if(res.code == '200'){
          this.attrs = res.data.commonAttributes;
        }
      }
    );
  }

  // 提取实体信息，并保存
  onSubmit(){
    if(!this.instance.conceptId){
      this.box.info('当前词条尚未绑定所属概念！');
      return;
    }
    if(this.datas.filter(el => el.selected).length == 0){
      this.box.info('请勾选需要进行三元组提取的属性信息!');
      return;
    }
    if(this.datas.filter(el => el.selected && !el.attributeId).length > 0){
      this.box.info('选中的部分属性尚未进行实体对齐操作!');
      return;
    }
    // 待保存的属性信息
    const attrModel = {
      "uuid": "",
      "materialId": "",
      "sourceText": "",
      "sourceMaterial": "",
      "pageNum": null,
      "relPageNum": null,
      "datasource": "",
      "attributeValue": "",
      "dictCode": "",
      "relationshipId": "",
      "relationshipName": "",
      "englishCode": "",
      "sortNum": 1,
      "isShow": true
    };
    let res = this.datas.filter(el => el.selected && el.value && el.attributeId);
    let saveAttrs = [];
    console.log(res,this.attrs);
    if(res.length>0){
      res.forEach(el => {
        let item = this.attrs.find(el1 => el1.attributeId == el.attributeId);
        if(item){
          let attrModel1 = JSON.parse(JSON.stringify(attrModel));
          attrModel1.relationshipId = item.attributeId;
          attrModel1.relationshipName = item.attributeName;
          attrModel1.englishCode = item.englishCode;
          attrModel1.sortNum = item.sortNum;
          attrModel1.attributeValue = el.value; 
          attrModel1.datasource = el.source;
          saveAttrs.push(attrModel1);
        }
      })
    }
    if(saveAttrs.length == 0){
      this.box.info('当前词条尚未完成实体对齐！');
      return;
    }
    this.instance.attributes = saveAttrs;
    console.log(saveAttrs);
    // 保存实体信息
    this.clickEnable = false;
    this.swMaskService.openMask("数据正在保存,请稍等...");
    this.kmsService.saveInstanceUpdate(this.instance).subscribe(
      result => {
          this.clickEnable = true;
          let datas = result.data;
          if (result.code == 200) {
            this.box.success('保存成功！');
            this.swMaskService.closeMask();
            // 增量更新索引
            this.updateIndex(datas.instanceId);
            this.modal.toggle();
            this.callback.emit(true);
          } else {
            this.swMaskService.closeMask();
            this.box.waring(result.msg);
          }
      }
    )
  }

  // 增量更新索引
  updateIndex(instanceId){
    this.kmsService.updateIndexByInstanceId(instanceId).subscribe(
        data => {
            if(data.code != '200'){
                console.log('索引更新失败!');
            }
        }
    )
  }
}
